import React, { Component } from "react";
import { observer } from "mobx-react";
import Core from "../../Core";
import MailPassword from "../../Core/Components/Buttons/MailPassword";
import moment from "moment";

export default observer(
  class UsersListRow extends Component {
    constructor(props) {
      super(props);

      this.handleOnMailFailure = this.handleOnMailFailure.bind(this);
    }

    onEditClicked() {
      const { user } = this.props;

      const hash = `#user-detail?id=${user.Id}`;
      window.location.hash = hash;
    }

    onDeleteClicked() {
      const result = window.confirm("Delete record?");
      if (result) {
        const { user } = this.props;
        user.store.deleteById(user.Id);
      }
    }

    handleOnMailFailure(error) {
      const { user } = this.props;

      window.alert(`Email to ${user.Name} could not be sent \r\nPlease check if the given email address is correct: ${user.Email}`);
    }

    render() {
      const { user, stores } = this.props;

      // Buttons for primary/admin
      let editButton = null;
      let deleteButton = null;
      let mailButton = null;
      if (stores.currentUser.user.isPrimaryUser || stores.currentUser.user.isAdmin) {
        editButton = <Core.Components.Buttons.Edit onClick={this.onEditClicked.bind(this)} />;
        deleteButton = <Core.Components.Buttons.Delete onClick={this.onDeleteClicked.bind(this)} />;
        mailButton = <MailPassword user={user} stores={stores} onFailure={this.handleOnMailFailure} />;
      }

      // UserRole
      let userRoleName = "";
      const userRole = stores.data.Enums.UserRoles.findByKey(user.RoleId);
      if (userRole) userRoleName = userRole.Name;

      let result = null;
      if (user) {
        result = (
          <tr>
            <td>{user.Name}</td>
            <td>{user.Email}</td>
            <td>{userRoleName}</td>
            <td>{moment(user.LastUpdated).format("L LTS")}</td>
            <td>{editButton}</td>
            <td>{mailButton}</td>
            <td>{deleteButton}</td>
          </tr>
        );
      }

      return result;
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/UsersList/UsersListRow.js